import React from 'react';

const ResponsiveLabelLg = (props) => {
    return <span className="d-md-inline-flex d-lg-none me-1 span-label font-weight-bold">{props.label}:</span>;
};

export default ResponsiveLabelLg;
